webpackJsonp([189060877874151],{

/***/ 197:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(18);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Pagination = function (_React$Component) {
	  _inherits(Pagination, _React$Component);
	
	  function Pagination() {
	    _classCallCheck(this, Pagination);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Pagination.prototype.render = function render() {
	    var _props$pathContext = this.props.pathContext,
	        index = _props$pathContext.index,
	        first = _props$pathContext.first,
	        last = _props$pathContext.last,
	        pageCount = _props$pathContext.pageCount,
	        pathPrefix = _props$pathContext.pathPrefix;
	
	    var previousUrl = index - 1 === 1 ? "/" + pathPrefix : (index - 1).toString();
	    var nextUrl = "/" + pathPrefix + "/" + (index + 1);
	
	    var previousButton = !first ? _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: previousUrl, className: "pagination-previous" },
	      "Previous"
	    ) :
	    /* eslint jsx-a11y/anchor-is-valid: "off" */
	    _react2.default.createElement(
	      "a",
	      { className: "pagination-previous", disabled: true },
	      "Previous"
	    );
	    var nextButton = !last ? _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: nextUrl, className: "pagination-next" },
	      "Next"
	    ) :
	    /* eslint jsx-a11y/anchor-is-valid: "off" */
	    _react2.default.createElement(
	      "a",
	      { className: "pagination-next", disabled: true },
	      "Next"
	    );
	
	    return _react2.default.createElement(
	      "nav",
	      { className: "pagination is-centered", "aria-label": "pagination", style: { marginBottom: "20px" } },
	      previousButton,
	      nextButton,
	      _react2.default.createElement(
	        "ul",
	        { className: "pagination-list" },
	        index > 2 ? _react2.default.createElement(
	          "li",
	          null,
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: "/" + pathPrefix + "/", className: "pagination-link", "aria-label": "Goto page 1" },
	            "1"
	          )
	        ) : null,
	        index > 3 ? _react2.default.createElement(
	          "li",
	          null,
	          _react2.default.createElement(
	            "span",
	            { className: "pagination-ellipsis" },
	            "\u2026"
	          )
	        ) : null,
	        index > 1 ? _react2.default.createElement(
	          "li",
	          null,
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            {
	              to: index - 1 > 1 ? "/" + pathPrefix + "/" + (index - 1) : "/" + pathPrefix + "/",
	              className: "pagination-link",
	              "aria-label": "Goto page " + (index - 1)
	            },
	            index - 1
	          )
	        ) : null,
	        _react2.default.createElement(
	          "li",
	          null,
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            {
	              to: index > 1 ? "/" + pathPrefix + "/" + index : "/" + pathPrefix,
	              className: "pagination-link is-current",
	              "aria-label": "Page " + index,
	              "aria-current": "page"
	            },
	            index
	          )
	        ),
	        pageCount - index > 0 ? _react2.default.createElement(
	          "li",
	          null,
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: "/" + pathPrefix + "/" + (index + 1), className: "pagination-link", "aria-label": "Goto page " + (index + 1) },
	            index + 1
	          )
	        ) : null,
	        pageCount - index > 2 ? _react2.default.createElement(
	          "li",
	          null,
	          _react2.default.createElement(
	            "span",
	            { className: "pagination-ellipsis" },
	            "\u2026"
	          )
	        ) : null,
	        pageCount - index > 1 ? _react2.default.createElement(
	          "li",
	          null,
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: "/" + pathPrefix + "/" + pageCount, className: "pagination-link", "aria-label": "Goto page " + pageCount },
	            pageCount
	          )
	        ) : null
	      )
	    );
	  };
	
	  return Pagination;
	}(_react2.default.Component);
	
	exports.default = Pagination;
	module.exports = exports["default"];

/***/ }),

/***/ 523:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(15);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _HeaderImage = __webpack_require__(58);
	
	var _HeaderImage2 = _interopRequireDefault(_HeaderImage);
	
	var _PostListing = __webpack_require__(153);
	
	var _PostListing2 = _interopRequireDefault(_PostListing);
	
	var _Pagination = __webpack_require__(197);
	
	var _Pagination2 = _interopRequireDefault(_Pagination);
	
	var _SiteConfig = __webpack_require__(14);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage(_ref) {
	  var data = _ref.data,
	      pathContext = _ref.pathContext;
	  var group = pathContext.group;
	
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(_reactHelmet2.default, { title: "Videos | " + _SiteConfig2.default.siteTitle }),
	    _react2.default.createElement(_HeaderImage2.default, { headerImage: data.videosHeaderImage }),
	    _react2.default.createElement(
	      "div",
	      { className: "section" },
	      _react2.default.createElement(
	        "div",
	        { className: "container", style: { paddingTop: "100px" } },
	        _react2.default.createElement(
	          "h1",
	          { className: "title is-1" },
	          "All Videos"
	        ),
	        _react2.default.createElement(
	          "h4",
	          { className: "subtitle is-4" },
	          data.allMarkdownRemark.totalCount + " videos"
	        ),
	        _react2.default.createElement(_PostListing2.default, {
	          postEdges: group,
	          dateFormat: _SiteConfig2.default.dateFormatOutput
	        }),
	        _react2.default.createElement(_Pagination2.default, { pathContext: pathContext })
	      )
	    )
	  );
	};
	exports.default = IndexPage;
	
	/* eslint no-undef: "off" */
	
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-videos-jsx-2e6333e9420d71836fcc.js